import { AdminToken, XSRF_TOKEN } from '_constants';
import axios from 'axios';
import Cookies from 'js-cookie';

export const baseURL = import.meta.env.VITE_URL;

export const api = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  responseType: 'json',
  timeout: 300000,
  withCredentials: true,
});

export const setCommonHeaders = (token: string) => {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  localStorage.setItem(AdminToken, token);
};

export const unsetCommonHeaders = () => {
  delete api.defaults.headers.common['Authorization'];
  localStorage.removeItem(AdminToken);
};

api.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error),
);

api.interceptors.request.use(
  (config) => {
    if (
      config.method?.toLowerCase() === 'post' ||
      config.method?.toLowerCase() === 'delete' ||
      config.method?.toLowerCase() === 'put'
    ) {
      const csrf = Cookies.get('XSRF-TOKEN');
      config.withCredentials = true;

      if (csrf) {
        config.headers[`X-${XSRF_TOKEN}`] = csrf;
      }
    }
    if (!config.headers.Authorization) {
      const token = localStorage.getItem(AdminToken);
      if (token) {
        setCommonHeaders(token);
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);
